module.exports = __webpack_public_path__ + "img/area-limit-btn-disabled.886115f4.png";